/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ShippersListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: ShippersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, HostBinding, EventEmitter, Input, Output, OnInit, ViewChild,
	trigger, transition, animate,
	style, state } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager }  from 'ng2-toastr';

import myGlobals = require('../globals');
import { ShippersData, ShippersService } from './Shippers.service';
import { ShippersSearchComponent }  from './ShippersSearch.component';

@Component({
	selector: 'my-Shippers',
	template: require('./ShippersList.component.html'),
	providers: [ShippersService],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.4s ease-in')
      ]),
      transition(':leave', [
        animate('0.7s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class ShippersListComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}
	
	ShippersList: ShippersData[];
	newShippers: ShippersData;
	selectedShippers: ShippersData;
	errorMessage: string;
	messages: string[];
	showAdd: boolean;
	@ViewChild(ShippersSearchComponent) filterComponent: ShippersSearchComponent;

	sortExpression: string = "ShipperID";
	filterExpression: string = "";
	pageIndex: number = 1;
	pageSize: number = 10;
	endRowIndex: number;
	rowsCount: number;
	pageCount: number;
	isFirstPage: boolean;

    private selectedId: string;

	constructor(
		private ShippersService: ShippersService,
		private route: ActivatedRoute,
		private router: Router,
		private toastr: ToastsManager
	) {
		this.newShippers = new ShippersData();
		this.pageSize = myGlobals.pageSize;
	}

	ngOnInit() {
		//this.ShippersService.getAll().subscribe(record => this.ShippersList=record);
		this.pageIndex = 1;
		this.isFirstPage = true;
		this.getShippersByPaging();

		/*
		this.ShippersList = this.route.params
			.switchMap((params: Params) => {
				this.selectedId = +params['id'];
				return this.service.getAll();
			});
		*/
	}

	// Get all records
	public getShippers() {
		this.ShippersService.getAll()
			.subscribe(data => this.ShippersList = data,
		error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error);
	}
	
	// On Search CLick on ShippersSearch Component
	onSearch(searchText: string) {
		// 1. Update this.filterExpression
		this.filterExpression = searchText;

		// 2. call getShippersByPaging method that will refresh the data
		this.pageIndex = 1;
		this.getShippersByPaging();
	}
	
	onSort(event, sortColumn: string)
	{
		// var target = event.target || event.srcElement || event.currentTarget;
		// var parent = target.parentNode;
		if (this.sortExpression === sortColumn)
			this.sortExpression = sortColumn + ' desc';
		else if (this.sortExpression === sortColumn + ' desc')
			this.sortExpression = sortColumn;
		else
			this.sortExpression = sortColumn;
		this.getShippersByPaging();
	}
	
	// Get records by paging
	getShippersByPaging() {
		this.ShippersService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
			.subscribe(data => {
				this.ShippersList=data.ShippersList;
				this.rowsCount=data.RowsCount;
				this.pageCount= Math.ceil(this.rowsCount / this.pageSize);
				if (this.pageIndex == 1)
					this.isFirstPage = true;
				else
					this.isFirstPage = false;
				if (this.pageIndex == this.pageCount)
					this.endRowIndex = this.rowsCount;
				else
					this.endRowIndex = this.pageIndex * this.pageSize;
			},
			error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error
		);
	}

	// Adds new record
	addShippers() {
		this.ShippersService.addShippersData(this.newShippers).subscribe(record => console.log(record));
		this.getShippers();
	}

	// Updates existing record
	updateShippers() {
		this.ShippersService.updateShippersData(this.selectedShippers).subscribe(record => console.log(record));
		this.getShippers();
	}

	// Deletes record with specified id
	deleteShippers(id: string) {
		if (window.confirm('Are you sure you want to delete this Shippers?') == true)
		{
			this.ShippersService.deleteShippers(id)
			.subscribe(data => this.getShippers(),
			error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { 
					this.toastr.success('Shippers record deleted successfully...', 'Delete Shippers');
					console.log('Shippers record deleted successfully...'); 
				}
			);
		}
	}

	// Go to First Page
	onFirstPage() {
		this.pageIndex = 1;
		this.getShippersByPaging();
	}

	// Go to Previous Page
	onPreviousPage() {
		if (this.pageIndex > 1) {
			this.pageIndex = this.pageIndex - 1;
			this.getShippersByPaging();
		}
	}

	// Refresh - Go to First Page
	onRefresh() {
		this.onFirstPage();
	}

	// Go to Next Page
	onNextPage() {
		if (this.pageIndex < this.pageCount) {
			this.pageIndex = this.pageIndex + 1;
			this.getShippersByPaging();
		}
	}

	// Go to Last Page
	onLastPage() {
		this.pageIndex = this.pageCount;
		this.getShippersByPaging();
	}

	// On Edit - Go to Edit page
	onSelect(item: ShippersData) {
		this.router.navigate(['/Shippers', item.ShipperID]);
	}

	// On Details - Go to Details page
	onSelectDetails(item: ShippersData) {
		this.router.navigate(['/Shippers/Details', item.ShipperID]);
	}

	// Set record as selected
	SelectShippers(item: ShippersData) {
		this.selectedShippers = item;
	}

	// Submits form
	submitForm(data: Object) {
		console.log(data);
	}

	// Logs message onto Console
	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Shippers/ShippersList.component.ts